import '../components/error_state.js';

import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { css, html, LitElement, type TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * Authenticated 404 page rendered inside `<fm-application-frame>` when
 * a signed-in user hits an unknown URL. Matches Figma screen
 * `01 – 404 angemeldet`: a danger-toned `<fm-error-state>` card with the
 * `circle-exclamation` icon, the German "Seite nicht gefunden" copy and
 * a "Zur Startseite" CTA pointing at `/home`. The application frame
 * supplies sidebar, header and breadcrumb chrome; the page itself
 * renders only the error card so it slots into the content column.
 *
 * The card title inside `<fm-error-state>` is rendered as the page's
 * `<h1>` (via the `heading-level="h1"` binding inside `<fm-error-state>`),
 * so the page has exactly one heading at the right semantic level. No
 * separate hidden heading is emitted.
 *
 * The public 404 lives in `not_found.ts`; the router fallback in
 * `app.ts` selects between the two based on the cached auth state.
 */
@customElement('fm-not-found-authenticated')
export class FmNotFoundAuthenticated extends LitElement {

    static styles = [
        css`
            :host {
                display: block;
            }
        `,
    ];

    render (): TemplateResult {
        return html`
            <fm-error-state
                tone="danger"
                .icon=${faCircleExclamation}
                heading="Seite nicht gefunden"
                description="Die angeforderte Seite existiert nicht."
                action-href="/home"
                action-label="Zur Startseite">
            </fm-error-state>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'fm-not-found-authenticated': FmNotFoundAuthenticated;
    }
}
